import { Map as ImmutableMap } from 'immutable';
import { isUnifiedEventObjectTypeId } from '../filterQueryFormat/ObjectTypeId';
import * as DSAssetFamilies from '../filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { makeDynamicFilterFamily } from '../filterQueryFormat/DynamicFilterFamilies';

/**
 * Transforms RequiredIdsByAssetFamily to use Web Visitors dynamic filter families
 */
export const transformRequiredIdsForWebVisitorsEvents = requiredIdsByAssetFamily => {
  return requiredIdsByAssetFamily.entrySeq().reduce((acc, [assetFamily, idSet]) => {
    const transformedAssetFamily = isUnifiedEventObjectTypeId(assetFamily) ? makeDynamicFilterFamily(DSAssetFamilies.WEB_VISITORS_EVENT, assetFamily) : assetFamily;
    return acc.set(transformedAssetFamily, idSet);
  }, ImmutableMap());
};